<template>
    <div id="availability">
        <div class="material-icons time-icon">access_time</div>
        <div class="content">
            <span class="time-label">{{ $t("calendar.generalAvailability") }}</span>
            <span class="time-sub-label">{{ $t("calendar.generalAvailabilityDesc") }}</span>
            <div v-for="(rule, index) in availability.rules" class="ruleItem">
                <div class="options">
                    <div class="days">
                        <a-select
                            class="select-item"
                            show-search
                            :placeholder="$t('message.selectDayys')"
                            :value="dayLabels[index]"
                            @change="updateDays($event, index)"
                        >
                            <a-select-option :value="daysHashcode(day.value)" v-for="(day, i) in days" :key="i">
                                {{ day.label[$i18n.locale] }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="option">
                        <a-select
                            class="select-item"
                            show-search
                            :placeholder="$t('message.selectStartHour')"
                            v-model="rule.from"
                        >
                            <a-select-option :value="hour" v-for="(hour, i) in hours" :key="i">
                                {{ hour }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="option">
                        <a-select
                            class="select-item"
                            show-search
                            :placeholder="$t('message.selectEndHour')"
                            v-model="rule.to"
                        >
                            <a-select-option :value="hour" v-for="(hour, i) in hours" :key="i">
                                {{ hour }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div
                        class="material-icons delete-icon"
                        v-if="availability.rules.length > 1"
                        @click="removeRule(index)"
                    >
                        close
                    </div>
                </div>
            </div>
            <SupsisButton
                class="add-new-availability"
                @click="addNewAvailability()"
                :class="getDisabled() ? 'disabled' : ''"
            >+ {{ $t("task.add") }}
            </SupsisButton>
            <a-select v-model="availability.timezone" show-search class="timezone-select">
                <a-select-option v-for="(value, index) in timezones" :key="index" :value="value">
                    {{ value }}
                </a-select-option>
            </a-select>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import moment from "moment-timezone";
import _ from "lodash";
import SupsisButton from "../../../../../components/common/SupsisButtonOld.vue";

const log = log2("Availability");
const momentTimezoneList = moment.tz.names();
export default {
    name: "Availability",
    components: { SupsisButton },
    props: {
        value: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            timezones: momentTimezoneList,
            days: [],
            actualDays: [
                {
                    label: {
                        en: "Monday",
                        ru: "Monday",
                        tr: "Pazartesi",
                        de: "Montag",
                        fr: "Lundi",
                        es: "Lunes",
                        ar: "ا��اثنين",
                        it: "Lunedì",
                    },
                    value: [1],
                },
                {
                    label: {
                        en: "Tuesday",
                        ru: "Tuesday",
                        tr: "Salı",
                        de: "Dienstag",
                        fr: "Mardi",
                        es: "Martes",
                        ar: "يوم الثلاثاء",
                        it: "Martedì",
                    },
                    value: [2],
                },
                {
                    label: {
                        en: "Wednesday",
                        ru: "Wednesday",
                        tr: "Çarşamba",
                        de: "Mittwoch",
                        fr: "Mercredi",
                        es: "Miércoles",
                        ar: "الاربعاء",
                        it: "Mercoledì",
                    },
                    value: [3],
                },
                {
                    label: {
                        en: "Thursday",
                        ru: "Thursday",
                        tr: "Perşembe",
                        de: "Donnerstag",
                        fr: "Jeudi",
                        es: "Jueves",
                        ar: "يوم الخميس",
                        it: "Giovedì",
                    },
                    value: [4],
                },
                {
                    label: {
                        en: "Friday",
                        ru: "Friday",
                        tr: "Cuma",
                        de: "Freitag",
                        fr: "Vendredi",
                        es: "Viernes",
                        ar: "جمعة",
                        it: "Venerdì",
                    },
                    value: [5],
                },
                {
                    label: {
                        en: "Saturday",
                        ru: "Saturday",
                        tr: "Cumartesi",
                        de: "Samstag",
                        fr: "Samedi",
                        es: "Sábado",
                        ar: "السبت",
                        it: "Sabato",
                    },
                    value: [6],
                },
                {
                    label: {
                        en: "Sunday",
                        ru: "Sunday",
                        tr: "Pazar",
                        de: "Sonntag",
                        fr: "Dimanche",
                        es: "Domingo",
                        ar: "الأحد",
                        it: "Domenica",
                    },
                    value: [7],
                },
            ],
            otherDays: [
                {
                    label: {
                        en: "Every Day",
                        ru: "Every Day",
                        tr: "Her Gün",
                        de: "Täglich",
                        fr: "Tous les jours",
                        es: "Cada día",
                        ar: "كل يوم",
                        it: "Ogni giorno",
                    },
                    value: [1, 2, 3, 4, 5, 6, 7],
                },
                {
                    label: {
                        en: "Mon - Fri",
                        ru: "Mon - Fri",
                        tr: "Pzt - Cuma",
                        de: "Mo - Freitag",
                        fr: "Lun - Vendredi",
                        es: "lun - viernes",
                        ar: "الاثنين - الجمعة",
                        it: "Lun - Ven",
                    },
                    value: [1, 2, 3, 4, 5],
                },
                {
                    label: {
                        en: "Sat - Sun",
                        ru: "Sat - Sun",
                        tr: "Cts - Pzr",
                        de: "Sa - So",
                        fr: "Sam-Dim",
                        es: "Sáb-dom",
                        ar: "اشعة الشمس",
                        it: "Sab-Dom",
                    },
                    value: [6, 7],
                },
            ],
            hours: [
                ...[...Array(48).keys()].map((v, i) =>
                    moment()
                        .startOf("day")
                        .add(v * 30, "minute")
                        .format("HH:mm")
                ),
                "23:59",
            ],
            availability: _.clone(this.value),
        };
    },
    computed: {
        ...mapState({}),
        ...mapGetters({}),
        dayLabels() {
            return this.availability.rules.map((rule) => {
                const selectedDays = this.actualDays.concat(this.otherDays);
                const matchedDay = selectedDays.find((day) =>
                    this.daysHashcode(day.value) === this.daysHashcode(rule.days)
                );
                return matchedDay ? matchedDay.label[this.$i18n.locale] : "";
            });
        },
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({}),
        updateDays(selectedValue, index) {
            let selectedArray;
            try {
                selectedArray = typeof selectedValue === 'string' ?
                    selectedValue.split('-').map(Number) : selectedValue;
            } catch (error) {
                console.error("Hatalı format:", error);
                return;
            }

            if (!Array.isArray(selectedArray)) {
                console.error("selectedArray bir dizi değil:", selectedArray);
                return;
            }

            const matchedDay = this.days.find((day) =>
                _.isEqual(
                    [...day.value].sort((a,b) => a - b),
                    [...selectedArray].sort((a,b) => a - b)
                )
            );

            if (matchedDay) {
                this.availability.rules[index].days = matchedDay.value;
            }
        },
        getDisabled() {
            return (
                this.availability.rules.length === 1 &&
                this.availability.rules.filter((x) =>
                    Array.isArray(x.days) && x.days.length > 1
                ).length > 0
            );
        },
        addNewAvailability() {
            if (this.getDisabled()) return;
            this.availability.rules.push({
                days: [1],
                from: "09:00",
                to: "18:00",
            });
        },
        daysHashcode(days) {
            return _.orderBy(days, (q) => q, "asc").join("-");
        },
        removeRule(index) {
            if (this.availability.rules.length > 1) {
                this.availability.rules = this.availability.rules.filter((rule, i) => i !== index);
            }
        },
    },
    async mounted() {
        if (this.availability.rules.length === 1) {
            this.days = [...this.otherDays, ...this.actualDays];
        } else {
            this.days = [...this.actualDays];
        }
    },
    beforeDestroy() {},
    watch: {
        availability: {
            handler(val) {
                if (this.availability.rules.length === 1) {
                    this.days = [...this.otherDays, ...this.actualDays];
                } else {
                    this.days = [...this.actualDays];
                }
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
#availability {
    .ant-select-selection {
        border: none !important;
        border-radius: 0 !important;
        margin-top: 6px;
        background-color: white !important;
    }

    .ant-select-selection__rendered {
        margin-left: 0 !important;
    }
}
</style>

<style lang="scss" scoped>
#availability {
    display: flex;
    flex-direction: row;
    margin-top: 20px;

    &.timezone {
        margin-top: 20px;
    }

    .time-icon {
        margin-top: 2px;
        margin-right: 20px;
        font-size: 20px;
    }

    .content {
        display: flex;
        flex-direction: column;

        .add-new-availability {
            cursor: pointer;
            border-radius: 10px;
            margin: 10px 0;
            padding: 5px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: fit-content;

            &.disabled {
                cursor: default;
                background-color: #e1e1e1;
            }
        }

        .time-label {
            color: black;
            font-weight: 500;
            font-size: 16px;
        }

        .time-sub-label {
            font-size: 12px;
        }

        .options {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .days {
                width: 40%;
            }

            .select-item {
                width: 100%;
            }

            .option {
                width: 25%;
            }

            .delete-icon {
                cursor: pointer;
                font-size: 20px;
                display: flex;
                align-items: center;
                height: fit-content;
                padding: 3px;
                border-radius: 3px;

                &:hover {
                    background-color: #e3e3e3;
                }
            }
        }
    }
}
</style>
